export default function removeHighlightFromTask ({ state, commit }, taskId) {
  if (state.highlightedTaskId === taskId) {
    commit('highlightTask', null)
  }
}
